"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TableFilterDialogItem = void 0;
const react_1 = __importDefault(require("react"));
const FormControlLabel_1 = __importDefault(require("@material-ui/core/FormControlLabel/FormControlLabel"));
const Checkbox_1 = __importDefault(require("@material-ui/core/Checkbox/Checkbox"));
const table_styles_1 = require("./table-styles");
/**
 * Filter dialog item.
 */
function TableFilterDialogItem({ filter, state, onToggle, onChangeValue, onChangeFilterState, }) {
    const classes = table_styles_1.useStyles();
    const { FilterComponent } = filter;
    return (react_1.default.createElement("div", { className: classes.filterDialogItem },
        react_1.default.createElement(FormControlLabel_1.default, { className: classes.columnDialogItemLabel, classes: { label: classes.dialogCheckBoxLabel }, label: filter.label, control: react_1.default.createElement(Checkbox_1.default, { checked: state === null || state === void 0 ? void 0 : state.enabled, color: "primary", onChange: onToggle }) }),
        (state === null || state === void 0 ? void 0 : state.enabled) && (react_1.default.createElement(FilterComponent, { filter: filter, state: state, disabled: !(state === null || state === void 0 ? void 0 : state.enabled), value: state.value, onChange: onChangeValue, onChangeState: onChangeFilterState }))));
}
exports.TableFilterDialogItem = TableFilterDialogItem;
//# sourceMappingURL=table-filter-dialog-item.js.map